/* __next_internal_client_entry_do_not_use__  cjs */ "use strict";
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _refType = _interopRequireDefault(require("@mui/utils/refType"));
var _composeClasses = _interopRequireDefault(require("@mui/utils/composeClasses"));
var _NotchedOutline = _interopRequireDefault(require("./NotchedOutline"));
var _useFormControl = _interopRequireDefault(require("../FormControl/useFormControl"));
var _formControlState = _interopRequireDefault(require("../FormControl/formControlState"));
var _rootShouldForwardProp = _interopRequireDefault(require("../styles/rootShouldForwardProp"));
var _zeroStyled = require("../zero-styled");
var _memoTheme = _interopRequireDefault(require("../utils/memoTheme"));
var _createSimplePaletteValueFilter = _interopRequireDefault(require("../utils/createSimplePaletteValueFilter"));
var _DefaultPropsProvider = require("../DefaultPropsProvider");
var _outlinedInputClasses = _interopRequireWildcard(require("./outlinedInputClasses"));
var _InputBase = _interopRequireWildcard(require("../InputBase/InputBase"));
var _useSlot = _interopRequireDefault(require("../utils/useSlot"));
var _jsxRuntime = require("react/jsx-runtime");
const useUtilityClasses = (ownerState)=>{
    const { classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        notchedOutline: [
            'notchedOutline'
        ],
        input: [
            'input'
        ]
    };
    const composedClasses = (0, _composeClasses.default)(slots, _outlinedInputClasses.getOutlinedInputUtilityClass, classes);
    return {
        ...classes,
        // forward classes to the InputBase
        ...composedClasses
    };
};
const OutlinedInputRoot = (0, _zeroStyled.styled)(_InputBase.InputBaseRoot, {
    shouldForwardProp: (prop)=>(0, _rootShouldForwardProp.default)(prop) || prop === 'classes',
    name: 'MuiOutlinedInput',
    slot: 'Root',
    overridesResolver: _InputBase.rootOverridesResolver
})((0, _memoTheme.default)((param)=>{
    let { theme } = param;
    const borderColor = theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)';
    return {
        position: 'relative',
        borderRadius: (theme.vars || theme).shape.borderRadius,
        ["&:hover .".concat(_outlinedInputClasses.default.notchedOutline)]: {
            borderColor: (theme.vars || theme).palette.text.primary
        },
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
            ["&:hover .".concat(_outlinedInputClasses.default.notchedOutline)]: {
                borderColor: theme.vars ? "rgba(".concat(theme.vars.palette.common.onBackgroundChannel, " / 0.23)") : borderColor
            }
        },
        ["&.".concat(_outlinedInputClasses.default.focused, " .").concat(_outlinedInputClasses.default.notchedOutline)]: {
            borderWidth: 2
        },
        variants: [
            ...Object.entries(theme.palette).filter((0, _createSimplePaletteValueFilter.default)()).map((param)=>{
                let [color] = param;
                return {
                    props: {
                        color
                    },
                    style: {
                        ["&.".concat(_outlinedInputClasses.default.focused, " .").concat(_outlinedInputClasses.default.notchedOutline)]: {
                            borderColor: (theme.vars || theme).palette[color].main
                        }
                    }
                };
            }),
            {
                props: {},
                // to overide the above style
                style: {
                    ["&.".concat(_outlinedInputClasses.default.error, " .").concat(_outlinedInputClasses.default.notchedOutline)]: {
                        borderColor: (theme.vars || theme).palette.error.main
                    },
                    ["&.".concat(_outlinedInputClasses.default.disabled, " .").concat(_outlinedInputClasses.default.notchedOutline)]: {
                        borderColor: (theme.vars || theme).palette.action.disabled
                    }
                }
            },
            {
                props: (param)=>{
                    let { ownerState } = param;
                    return ownerState.startAdornment;
                },
                style: {
                    paddingLeft: 14
                }
            },
            {
                props: (param)=>{
                    let { ownerState } = param;
                    return ownerState.endAdornment;
                },
                style: {
                    paddingRight: 14
                }
            },
            {
                props: (param)=>{
                    let { ownerState } = param;
                    return ownerState.multiline;
                },
                style: {
                    padding: '16.5px 14px'
                }
            },
            {
                props: (param)=>{
                    let { ownerState, size } = param;
                    return ownerState.multiline && size === 'small';
                },
                style: {
                    padding: '8.5px 14px'
                }
            }
        ]
    };
}));
const NotchedOutlineRoot = (0, _zeroStyled.styled)(_NotchedOutline.default, {
    name: 'MuiOutlinedInput',
    slot: 'NotchedOutline',
    overridesResolver: (props, styles)=>styles.notchedOutline
})((0, _memoTheme.default)((param)=>{
    let { theme } = param;
    const borderColor = theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)';
    return {
        borderColor: theme.vars ? "rgba(".concat(theme.vars.palette.common.onBackgroundChannel, " / 0.23)") : borderColor
    };
}));
const OutlinedInputInput = (0, _zeroStyled.styled)(_InputBase.InputBaseInput, {
    name: 'MuiOutlinedInput',
    slot: 'Input',
    overridesResolver: _InputBase.inputOverridesResolver
})((0, _memoTheme.default)((param)=>{
    let { theme } = param;
    return {
        padding: '16.5px 14px',
        ...!theme.vars && {
            '&:-webkit-autofill': {
                WebkitBoxShadow: theme.palette.mode === 'light' ? null : '0 0 0 100px #266798 inset',
                WebkitTextFillColor: theme.palette.mode === 'light' ? null : '#fff',
                caretColor: theme.palette.mode === 'light' ? null : '#fff',
                borderRadius: 'inherit'
            }
        },
        ...theme.vars && {
            '&:-webkit-autofill': {
                borderRadius: 'inherit'
            },
            [theme.getColorSchemeSelector('dark')]: {
                '&:-webkit-autofill': {
                    WebkitBoxShadow: '0 0 0 100px #266798 inset',
                    WebkitTextFillColor: '#fff',
                    caretColor: '#fff'
                }
            }
        },
        variants: [
            {
                props: {
                    size: 'small'
                },
                style: {
                    padding: '8.5px 14px'
                }
            },
            {
                props: (param)=>{
                    let { ownerState } = param;
                    return ownerState.multiline;
                },
                style: {
                    padding: 0
                }
            },
            {
                props: (param)=>{
                    let { ownerState } = param;
                    return ownerState.startAdornment;
                },
                style: {
                    paddingLeft: 0
                }
            },
            {
                props: (param)=>{
                    let { ownerState } = param;
                    return ownerState.endAdornment;
                },
                style: {
                    paddingRight: 0
                }
            }
        ]
    };
}));
const OutlinedInput = /*#__PURE__*/ React.forwardRef(function OutlinedInput(inProps, ref) {
    const props = (0, _DefaultPropsProvider.useDefaultProps)({
        props: inProps,
        name: 'MuiOutlinedInput'
    });
    const { components = {}, fullWidth = false, inputComponent = 'input', label, multiline = false, notched, slots = {}, slotProps = {}, type = 'text', ...other } = props;
    const classes = useUtilityClasses(props);
    const muiFormControl = (0, _useFormControl.default)();
    const fcs = (0, _formControlState.default)({
        props,
        muiFormControl,
        states: [
            'color',
            'disabled',
            'error',
            'focused',
            'hiddenLabel',
            'size',
            'required'
        ]
    });
    const ownerState = {
        ...props,
        color: fcs.color || 'primary',
        disabled: fcs.disabled,
        error: fcs.error,
        focused: fcs.focused,
        formControl: muiFormControl,
        fullWidth,
        hiddenLabel: fcs.hiddenLabel,
        multiline,
        size: fcs.size,
        type
    };
    var _slots_root, _ref;
    const RootSlot = (_ref = (_slots_root = slots.root) !== null && _slots_root !== void 0 ? _slots_root : components.Root) !== null && _ref !== void 0 ? _ref : OutlinedInputRoot;
    var _slots_input, _ref1;
    const InputSlot = (_ref1 = (_slots_input = slots.input) !== null && _slots_input !== void 0 ? _slots_input : components.Input) !== null && _ref1 !== void 0 ? _ref1 : OutlinedInputInput;
    const [NotchedSlot, notchedProps] = (0, _useSlot.default)('notchedOutline', {
        elementType: NotchedOutlineRoot,
        className: classes.notchedOutline,
        shouldForwardComponentProp: true,
        ownerState,
        externalForwardedProps: {
            slots,
            slotProps
        },
        additionalProps: {
            label: label != null && label !== '' && fcs.required ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)(React.Fragment, {
                children: [
                    label,
                    "\u2009",
                    '*'
                ]
            }) : label
        }
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_InputBase.default, {
        slots: {
            root: RootSlot,
            input: InputSlot
        },
        slotProps: slotProps,
        renderSuffix: (state)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(NotchedSlot, {
                ...notchedProps,
                notched: typeof notched !== 'undefined' ? notched : Boolean(state.startAdornment || state.filled || state.focused)
            }),
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type,
        ...other,
        classes: {
            ...classes,
            notchedOutline: null
        }
    });
});
"production" !== "production" ? OutlinedInput.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * This prop helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
   */ autoComplete: _propTypes.default.string,
    /**
   * If `true`, the `input` element is focused during the first mount.
   */ autoFocus: _propTypes.default.bool,
    /**
   * Override or extend the styles applied to the component.
   */ classes: _propTypes.default.object,
    /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * The prop defaults to the value (`'primary'`) inherited from the parent FormControl component.
   */ color: _propTypes.default/* @typescript-to-proptypes-ignore */ .oneOfType([
        _propTypes.default.oneOf([
            'primary',
            'secondary'
        ]),
        _propTypes.default.string
    ]),
    /**
   * The components used for each slot inside.
   *
   * @deprecated use the `slots` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */ components: _propTypes.default.shape({
        Input: _propTypes.default.elementType,
        Root: _propTypes.default.elementType
    }),
    /**
   * The default value. Use when the component is not controlled.
   */ defaultValue: _propTypes.default.any,
    /**
   * If `true`, the component is disabled.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */ disabled: _propTypes.default.bool,
    /**
   * End `InputAdornment` for this component.
   */ endAdornment: _propTypes.default.node,
    /**
   * If `true`, the `input` will indicate an error.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */ error: _propTypes.default.bool,
    /**
   * If `true`, the `input` will take up the full width of its container.
   * @default false
   */ fullWidth: _propTypes.default.bool,
    /**
   * The id of the `input` element.
   */ id: _propTypes.default.string,
    /**
   * The component used for the `input` element.
   * Either a string to use a HTML element or a component.
   * @default 'input'
   */ inputComponent: _propTypes.default.elementType,
    /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   * @default {}
   */ inputProps: _propTypes.default.object,
    /**
   * Pass a ref to the `input` element.
   */ inputRef: _refType.default,
    /**
   * The label of the `input`. It is only used for layout. The actual labelling
   * is handled by `InputLabel`.
   */ label: _propTypes.default.node,
    /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   * The prop defaults to the value (`'none'`) inherited from the parent FormControl component.
   */ margin: _propTypes.default.oneOf([
        'dense',
        'none'
    ]),
    /**
   * Maximum number of rows to display when multiline option is set to true.
   */ maxRows: _propTypes.default.oneOfType([
        _propTypes.default.number,
        _propTypes.default.string
    ]),
    /**
   * Minimum number of rows to display when multiline option is set to true.
   */ minRows: _propTypes.default.oneOfType([
        _propTypes.default.number,
        _propTypes.default.string
    ]),
    /**
   * If `true`, a [TextareaAutosize](https://mui.com/material-ui/react-textarea-autosize/) element is rendered.
   * @default false
   */ multiline: _propTypes.default.bool,
    /**
   * Name attribute of the `input` element.
   */ name: _propTypes.default.string,
    /**
   * If `true`, the outline is notched to accommodate the label.
   */ notched: _propTypes.default.bool,
    /**
   * Callback fired when the value is changed.
   *
   * @param {React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */ onChange: _propTypes.default.func,
    /**
   * The short hint displayed in the `input` before the user enters a value.
   */ placeholder: _propTypes.default.string,
    /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */ readOnly: _propTypes.default.bool,
    /**
   * If `true`, the `input` element is required.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */ required: _propTypes.default.bool,
    /**
   * Number of rows to display when multiline option is set to true.
   */ rows: _propTypes.default.oneOfType([
        _propTypes.default.number,
        _propTypes.default.string
    ]),
    /**
   * The props used for each slot inside.
   * @default {}
   */ slotProps: _propTypes.default.shape({
        input: _propTypes.default.object,
        notchedOutline: _propTypes.default.oneOfType([
            _propTypes.default.func,
            _propTypes.default.object
        ]),
        root: _propTypes.default.object
    }),
    /**
   * The components used for each slot inside.
   * @default {}
   */ slots: _propTypes.default.shape({
        input: _propTypes.default.elementType,
        notchedOutline: _propTypes.default.elementType,
        root: _propTypes.default.elementType
    }),
    /**
   * Start `InputAdornment` for this component.
   */ startAdornment: _propTypes.default.node,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: _propTypes.default.oneOfType([
        _propTypes.default.arrayOf(_propTypes.default.oneOfType([
            _propTypes.default.func,
            _propTypes.default.object,
            _propTypes.default.bool
        ])),
        _propTypes.default.func,
        _propTypes.default.object
    ]),
    /**
   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types).
   * @default 'text'
   */ type: _propTypes.default.string,
    /**
   * The value of the `input` element, required for a controlled component.
   */ value: _propTypes.default.any
} : void 0;
OutlinedInput.muiName = 'Input';
var _default = exports.default = OutlinedInput;
